import BaseModel from "./base/baseModel";

export default class IncompatibilidadeKitEmbalagemModel extends BaseModel {
    id?: number = null;
    produtoId: number = null;
    kitEmbalagemIncompativelId: number = null;
    kitEmbalagemIncompativelDescricao = "";
}
